import { isClientModule, type ClientModule } from './types/client';

const { VITE_ENABLED_MODULES } = import.meta.env;

export const enabledModulesValidation = (): ClientModule[] => {
  if (!VITE_ENABLED_MODULES) return [];
  const splitModules = VITE_ENABLED_MODULES.split(',')
    .map((module) => module.trim())
    .filter((module) => module.length > 0);
  const validModules = splitModules.filter(isClientModule);
  if (validModules.length !== splitModules.length) {
    throw new Error(`Invalid VITE_ENABLED_MODULES value: ${VITE_ENABLED_MODULES}`);
  }
  return validModules;
};
